/** ANCHOR: vk-group-announcement-modal — UI модалки (удалить вместе с boot и константами). */
import React from 'react';
import {
  VK_GROUP_ANNOUNCEMENT_IMAGE,
  VK_GROUP_ANNOUNCEMENT_MESSAGE,
  VK_GROUP_URL,
} from '../../constants/vkGroupAnnouncement';
import './VkGroupAnnouncementModal.css';

const vkPostImageUrl = `${process.env.PUBLIC_URL}/notifications/${VK_GROUP_ANNOUNCEMENT_IMAGE}`;

export default function VkGroupAnnouncementModal({ onClose }) {
  return (
    <div
      className="vk-announce-modal__backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Мы теперь в VK"
    >
      <div className="vk-announce-modal__panel" onClick={(e) => e.stopPropagation()}>
        <img
          src={vkPostImageUrl}
          alt="MatchWear — мы теперь в VK"
          className="vk-announce-modal__image"
          width={512}
          height={512}
        />
        <p className="vk-announce-modal__message">
          {VK_GROUP_ANNOUNCEMENT_MESSAGE}{' '}
          <a
            href={VK_GROUP_URL}
            className="vk-announce-modal__link"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            {VK_GROUP_URL}
          </a>
        </p>
        <button type="button" className="vk-announce-modal__btn" onClick={onClose}>
          Понятно
        </button>
      </div>
    </div>
  );
}
